module.exports = __webpack_public_path__ + "img/best-campsites-uk.2.9023e34.jpg";